import { useTranslation } from "react-i18next";
import FlatList from "src/components/FlatList";
import TaskInviteCard from "src/components/network/TaskInviteCard";
import useGet from "src/hooks/rest/useGet";

const DashboardNetworkStudentView = () => {
	const { t } = useTranslation("network-view", {
		keyPrefix: "network-student-view",
	});
	const [result, loading, { fetchNext }] = useGet(
		"/student/task-invites",
		{ data: [] },
		true
	);
	const { data, hasMore, meta } = result;
	const total = meta?.total || 0;

	return (
		<FlatList
			{...{ loading, hasMore }}
			title={t("title", {
				count: total,
			})}
			data={data || []}
			onNext={async () => {
				if (hasMore) await fetchNext();
			}}
			columns={2}
			empty={{
				title: t("empty"),
			}}
			renderItem={(row: any) => (
				<TaskInviteCard key={row.hid} invite={row} />
			)}
		/>
	);
};

export default DashboardNetworkStudentView;
